import ArtifactGroupType from "../base/ArtifactGroupType";

const GoddessOfFertility = {
  id: '101',
  name: 'Goddess Of Fertility',
  icon: 'GoddessOfFertility',
  groupIcon: 'FoundationsOfCivilization',
  type: ArtifactGroupType.FOUNDATIONS_OF_CIVILIZATION,
  power: 10
};

export default GoddessOfFertility;
